
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/launch-pad",
      function () {
        return require("private-next-pages/launch-pad.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/launch-pad"])
      });
    }
  